import React from 'react'
import { Redirect } from 'react-router-dom'
import { Presentation } from 'views/Presentation'
import { Login } from 'views/Login'
import { EsqueceuSenha } from 'views/EsqueceuSenha'
import { RedefinirSenha } from 'views/RedefinirSenha'
import { Error401 } from 'views/Error401'
import { Error404 } from 'views/Error404'
import { Error500 } from 'views/Error500'
import { DashboardDefault } from 'views/DashboardDefault'
import { Usuarios } from 'views/Usuarios/Usuarios'
import { EditarUsuario } from 'views/Usuarios/EditarUsuario'
import { Vestigio } from 'views/Vestigios/Vestigio'
import { EncaminharVestigio } from 'views/Vestigios/Processamento/EncaminharVestigio'
import { CancelarEncaminharVestigio } from 'views/Vestigios/Processamento/CancelarEncaminharVestigio'
import { DescartarVestigio } from 'views/Vestigios/Processamento/DescartarVestigio'
import { GuardarVestigio } from 'views/Vestigios/Processamento/Guardar/GuardarVestigio'
import { RetornarVestigio } from 'views/Vestigios/RetornarVestigio'
import { FormTermoNaoConformidade } from 'views/Vestigios/FormTermoNaoConformidade'
import { MeusVestigios } from 'views/Vestigios/MeusVestigios'
import { VestigiosDoSetor } from 'views/Vestigios/VestigiosDoSetor'
import { Cargos } from 'views/Cargos/Cargos'
import { EditarCargo } from 'views/Cargos/EditarCargo'
import { Casos } from 'views/Casos/Casos'
import { CasosDoSetor } from 'views/Casos/CasosDoSetor'
import { Caso } from 'views/Casos/Caso'
import { EditarCaso } from 'views/Casos/EditarCaso'
import { EditarSolicitacao } from 'views/SolicitacoesExames/EditarSolicitacao'
import { SolicitacaoExames } from 'views/SolicitacoesExames/SolicitacaoExames'
import { ExameSolicitado } from 'views/ExamesSolicitados/ExameSolicitado'
import { ExameGenerico } from 'views/ExamesRealizados/ExameGenerico'
import { ExameNecroscopico } from 'views/ExamesRealizados/ExameNecroscopico'
import { ExameLocalAchadoCadaver } from 'views/ExamesRealizados/ExameLocalAchadoCadaver'
import { ExameConstatacao } from 'views/ExamesRealizados/ExameConstatacao'
import { EditorDocumento } from 'views/ExamesRealizados/EditorDocumento'
import { MeusCasos } from 'views/Casos/MeusCasos'
import { Exames } from 'views/Exames/Exames'
import { EditarExame } from 'views/Exames/EditarExame'
import { Orgaos } from 'views/Orgaos/Orgaos/Orgaos'
import { EditarOrgao } from 'views/Orgaos/Orgaos/EditarOrgao'
import { Regionais } from 'views/Orgaos/Regionais/Regionais'
import { EditarRegional } from 'views/Orgaos/Regionais/EditarRegional'
import { Divisoes } from 'views/Orgaos/Divisoes/Divisoes'
import { EditarDivisao } from 'views/Orgaos/Divisoes/EditarDivisao'
import { Setores } from 'views/Orgaos/Setores/Setores'
import { EditarSetor } from 'views/Orgaos/Setores/EditarSetor'
import { EditarVeiculo } from 'views/Veiculos/EditarVeiculo'
import { Veiculo } from 'views/Veiculos/Veiculo'
import { FormEditarVestigio } from 'views/Vestigios/FormEditarVestigio'
import { LogsServidor } from 'views/Log/Servidor'
import { MeusExamesSolicitados } from 'views/ExamesSolicitados/MeusExamesSolicitados'
import { ExamesSolicitadosDoSetor } from 'views/ExamesSolicitados/ExamesSolicitadosDoSetor'
import { DadosGerenciaveis } from 'views/GerenciamentoBalistica/DadosGerenciaveis'
import { DadoGerenciavel } from 'views/GerenciamentoBalistica/DadoGerenciavel'
import { ValidarDocumento } from 'views/ValidarDocumento'
import { DocumentoValidado } from 'views/ValidarDocumento/DocumentoValidado'
import { EditarPericiando } from 'views/Periciandos/EditarPericiando'
import { Periciando } from 'views/Periciandos/Periciando/Periciando'
import { EditarCadaver } from 'views/Cadaveres/EditarCadaver/EditarCadaver'
import { EditarLocal } from 'views/Locais/EditarLocal/EditarLocal'
import { ExtracaoVestigio } from 'views/Vestigios/ExtracaoVestigio'
import { Local } from 'views/Locais/Local/Local'
import { Cadaver } from 'views/Cadaveres/Cadaver/Cadaver'
import { ListaVestigios } from 'views/Vestigios/ListaVestigios/ListaVestigios'
import { ReconhecimentoCadaver } from 'views/Cadaveres/ReconhecimentoCadaver/ReconhecimentoCadaver'
import { EntregaCadaver } from 'views/Cadaveres/EntregaCadaver/EntregaCadaver'
import { PassarCustodia } from 'views/Vestigios/Processamento/PassarCustodia'
import { SolicitarValidacao } from 'views/UsuarioPendente/SolicitarValidacao'
import { ValidarUsuario } from 'views/UsuarioPendente/ValidarUsuario/'
import { EntregarVestigio } from 'views/Vestigios/EntregarVestigio'
import { ConsumirVestigio } from 'views/Vestigios/ConsumirVestigio'
import { ExameNecropapiloscopico } from 'views/ExamesRealizados/ExameNecropapiloscopico'
import { ExameIdentificacaoCadaverica } from 'views/ExamesRealizados/ExameIdentificacaoCadaverica'
import { ExameComparacao } from 'views/ExamesRealizados/ExameComparacao'
import { ExameIdentificacaoCriminal } from 'views/ExamesRealizados/ExameIdentificacaoCriminal'
import { ExameEficienciaBalistica } from 'views/ExamesRealizados/ExameBalistico/ExameEficienciaBalistica'
import { ExameCoincidenciaPerfis } from 'views/ExamesRealizados/ExameBalistico/ExameCoincidencia'
import { ExameIdentificacaoBalistica } from 'views/ExamesRealizados/ExameBalistico/ExameIdentificacaoBalistica'
import { InformacaoSINAB } from 'views/ExamesRealizados/ExameBalistico/InformacaoSINAB/index'
import { BancoDeExames } from 'views/ExamesRealizados/BancoDeExames'
import { FormularioSecao } from 'views/Exames/EditarExame/components/FormularioSecao'
import { BancoDeCadaveres } from 'views/Cadaveres/BancoDeCadaveres/BancoDeCadaveres'
import { ListaCadaveresPublica } from 'views/Cadaveres/ListaCadaveresPublica'
import { GerenciamentoDeVagas } from 'views/GerenciamentoVagas/GerenciamentoVagas/GerenciamentoDeVagas'
import { ListaSecoes } from 'views/Exames/EditarExame/components/ListaSecoes'
import { CadastroDeVagas } from 'views/GerenciamentoVagas/CadastroVagas/CadastroDeVagas'
import { FichaSolicitacaoExame } from 'views/SolicitacoesExames/FichaSolicitacaoExames/index'
import { ReportPage } from './views/ReportPage/ReportPage/index'
import { CadastroReport } from './views/ReportPage/CadatroReport/index'
import { GerenciarReport } from './views/ReportPage/GerenciarReport/index'
import { CancelarExame } from './views/ExamesSolicitados/CancelarExame/index'
import { BancoDePericiando } from './views/Periciandos/BancoDePericiando/index'
import { CadastrarAnuncio } from './views/Anuncio/CadastrarAnuncio/index'
import { Error as ErrorLayout } from './layouts/Error'
import { Auth as AuthLayout } from './layouts/Auth'
import { Dashboard as DashboardLayout } from './layouts/Dashboard'
import { Publico as PublicoLayout } from './layouts/Publico'
import { FormularioInformacao } from 'views/Informacao/FomularioInformacao'
import { Anuncios } from 'views/Anuncio/Anuncios/index'
import { InumarCadaver } from 'views/Cadaveres/InumarCadaver'
import { ExumarCadaver } from 'views/Cadaveres/ExumarCadaver'
import { Anuncio } from 'views/Anuncio'
import { ExameMausTratos } from 'views/ExamesRealizados/ExameMausTratos'
import { AlterarStatusExame } from 'views/ExamesSolicitados/AlterarStatus'
import { ExameQuimico } from 'views/ExamesRealizados/ExameQuimico'
import { Requisicoes } from 'views/Requisicoes/index'
import { Requisicao } from 'views/Requisicoes/Requisicao/Requisicao'
import { Lote } from 'views/Vestigios/Lote'
import { Despachos } from 'views/SolicitacoesExames/Despachos'
import { ListaSolicitacoes } from 'views/SolicitacoesExames/ListaSolicitacoes'
import { EditarExameSolicitado } from 'views/SolicitacoesExames/EditarExameSolicitado'
import { Galeria } from 'components/Galeria'
import { CentralDeCustodia } from 'views/Vestigios/CentralDeCustodia'
import { ExameNecrodontoscopico } from 'views/ExamesRealizados/ExameNecrodontoscopico'
import { ExameImovel } from 'views/ExamesRealizados/ExameImovel'
import { ExameAmbiental } from 'views/ExamesRealizados/ExameAmbiental'
import { ExameTentativaHomicidio } from 'views/ExamesRealizados/ExameTentativaHomicidio'
import { ExameLocal } from 'views/ExamesSolicitados/ExameLocal'

const routes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: Login,
      },
      {
        path: '/auth/esqueceu',
        exact: true,
        component: EsqueceuSenha,
      },
      {
        path: '/auth/redefinir/:token',
        exact: true,
        component: RedefinirSenha,
      },
      {
        path: '/auth/usuariopendente',
        exact: true,
        component: SolicitarValidacao,
      },
      {
        path: '/auth/validarusuario/:token/:idUsuario',
        exact: true,
        component: ValidarUsuario,
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: Error401,
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: Error404,
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: Error500,
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: '/publico',
    component: PublicoLayout,
    routes: [
      {
        path: '/publico/validar-documento',
        exact: true,
        component: ValidarDocumento,
      },
      {
        path: `/publico/validar-documento/documento/:tipoDocumento`,
        exact: true,
        component: DocumentoValidado,
      },
      {
        path: '/publico/listagem-cadaveres',
        exact: true,
        component: ListaCadaveresPublica,
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/dashboard', //! Página de lista de usuários do sistema
        secao: 'Dashboard',
        titulo: 'Dashboard',
        exact: true,
        component: DashboardDefault,
      },
      {
        path: '/usuarios', //! Página de lista de usuários do sistema
        secao: 'Usuários',
        titulo: 'Usuários',
        exact: true,
        component: Usuarios,
      },
      {
        path: '/usuarios/cadastrar', //! Página de criação de usuário para o sistema
        editar: false,
        secao: 'Usuários',
        titulo: 'Cadastrar usuário',
        exact: true,
        component: EditarUsuario,
      },
      {
        path: '/usuarios/editar/:idUsuario', //! Página de edição de usuário do sistema
        editar: true,
        secao: 'Usuários',
        titulo: 'Editar usuário',
        exact: true,
        component: EditarUsuario,
      },
      {
        path: '/vestigios/vestigio/guardar/:id',
        editar: true,
        secao: 'Guardar vestígio',
        titulo: 'Guardar vestígio no setor',
        exact: true,
        component: GuardarVestigio,
      },
      {
        path: '/vestigios/vestigio/retornar/:id',
        editar: true,
        secao: 'Guardar vestígio',
        titulo: 'Guardar vestígio no setor',
        exact: true,
        component: RetornarVestigio,
      },
      {
        path: '/vestigios/vestigio/editar-de-extracao/:id',
        editar: true,
        secao: 'Editar Vestígio',
        titulo: 'Editar Vestígio',
        exact: true,
        component: ExtracaoVestigio,
      },
      {
        path: '/vestigio/gerarTermoNaoConformidade/:idVestigio',
        secao: 'Gerar Termo de Não Conformidade',
        titulo: 'Gerar Termo de Não Conformidade',
        editar: false,
        exact: true,
        component: FormTermoNaoConformidade,
      },
      {
        path: '/cargos',
        secao: 'Cargos',
        titulo: 'Cargos',
        exact: true,
        component: Cargos,
      },
      {
        path: '/cargos/cadastrar',
        editar: false,
        secao: 'Cargos',
        titulo: 'Cadastrar cargo',
        exact: true,
        component: EditarCargo,
      },
      {
        path: '/cargos/editar',
        editar: true,
        secao: 'Cargos',
        titulo: 'Editar cargo',
        exact: true,
        component: EditarCargo,
      },
      {
        path: '/casos',
        secao: 'Casos',
        titulo: 'Casos',
        exact: true,
        component: Casos,
      },
      {
        path: '/casos/caso/detalhar/:id',
        secao: 'Detalhes do caso',
        titulo: 'Detalhes do caso',
        exact: true,
        component: Caso,
      },
      {
        path: '/casos/caso/editar/:id',
        editar: true,
        secao: 'Casos',
        titulo: 'Editar caso',
        exact: true,
        component: EditarCaso,
      },
      {
        path: '/casos/caso/cadastrarvestigio/:idCaso',
        editar: false,
        secao: 'Vestígios',
        titulo: 'Cadastrar vestígio',
        exact: true,
        component: FormEditarVestigio,
      },
      {
        path: '/casos/caso/vestigio/encaminhar/:id',
        editar: false,
        paraUsuario: false,
        secao: 'Vestígios',
        titulo: 'Encaminhar vestígio',
        exact: true,
        component: EncaminharVestigio,
      },
      {
        path: '/casos/caso/vestigio/encaminharParaUsuario/:id',
        editar: false,
        paraUsuario: true,
        secao: 'Vestígios',
        titulo: 'Encaminhar vestígio para usuário',
        exact: true,
        component: EncaminharVestigio,
      },
      {
        path: '/casos/caso/vestigio/passarcustodia/:id',
        editar: false,
        secao: 'Passar custódia do vestígio',
        titulo: 'Passar custódia do vestígio',
        exact: true,
        component: PassarCustodia,
      },
      {
        path: '/casos/caso/vestigio/entregar/:id',
        editar: false,
        secao: 'Entregar vestígio ao destino final',
        titulo: 'Entregar vestígio ao destino final',
        exact: true,
        component: EntregarVestigio,
      },
      {
        path: '/casos/caso/cadastrarsolicitacao/:idCaso',
        editar: false,
        secao: 'Solicitação de exame',
        titulo: 'Formulário de solicitação de exame',
        exact: true,
        origem: 'SOLICITACAO',
        component: EditarSolicitacao,
      },
      {
        path: '/requisicao/cadastrar',
        editar: false,
        secao: 'Solicitação de exame',
        titulo: 'Formulário de solicitação de exame',
        exact: true,
        origem: 'REQUISICAO',
        component: EditarSolicitacao,
      },
      {
        path: '/solicitacao/exame/confirmar/:id',
        secao: 'Confirmação de exame',
        titulo: 'Confirmação de exame',
        exact: true,
        origem: 'CONFIRMACAO',
        component: EditarExameSolicitado,
      },
      {
        path: '/casos/caso/cadastrarpericiando/:idCaso',
        editar: false,
        secao: 'Periciandos',
        titulo: 'Cadastrar periciando',
        exact: true,
        component: EditarPericiando,
      },
      {
        path: '/casos/caso/editarPericiando/:id',
        editar: true,
        secao: 'Periciandos',
        titulo: 'Editar periciando',
        exact: true,
        component: EditarPericiando,
      },
      {
        path: '/casos/caso/periciando/detalhar/:id',
        editar: true,
        secao: 'Periciandos',
        titulo: 'Detalhes do Periciando',
        exact: true,
        component: Periciando,
      },
      {
        path: '/casos/caso/periciando/extrair/:id',
        exact: true,
        titulo: 'Extrair vestígio',
        secao: 'Extrair vestígio',
        origem: 'PERICIANDO',
        component: ExtracaoVestigio,
      },
      {
        path: '/casos/caso/cadastrarCadaver/:idCaso',
        editar: false,
        secao: 'Cadáver',
        titulo: 'Cadastrar cadáver',
        exact: true,
        component: EditarCadaver,
      },
      {
        path: '/casos/caso/cadastrarlocal/:idCaso',
        editar: false,
        secao: 'Local',
        titulo: 'Cadastrar local',
        exact: true,
        component: EditarLocal,
      },
      {
        path: '/casos/caso/local/editarLocal/:id',
        editar: true,
        secao: 'Local',
        titulo: 'Editar local',
        exact: true,
        component: EditarLocal,
      },
      {
        path: '/casos/caso/local/detalhar/:id',
        secao: 'Local',
        titulo: 'Detalhes do Local',
        exact: true,
        component: Local,
      },
      {
        path: '/casos/caso/cadaver/editarCadaver/:idCadaver',
        editar: true,
        secao: 'Cadáver',
        titulo: 'Editar cadáver',
        exact: true,
        component: EditarCadaver,
      },
      {
        path: '/casos/cadastrar',
        editar: false,
        secao: 'Casos',
        titulo: 'Cadastrar caso',
        exact: true,
        casoRelacionado: false,
        component: EditarCaso,
      },
      {
        path: '/casos/cadastrar/:idRequisicao',
        editar: false,
        secao: 'Casos',
        titulo: 'Criar caso relacionado',
        exact: true,
        casoRelacionado: true,
        component: EditarCaso,
      },
      {
        path: '/casos/cadastrar/:idRequisicao',
        editar: false,
        secao: 'Casos',
        titulo: 'Criar caso relacionado',
        exact: true,
        casoRelacionado: true,
        component: EditarCaso,
      },
      {
        path: '/casos/caso/vestigio/detalhar/:id',
        secao: 'Detalhes do vestígio',
        titulo: 'Detalhes do vestígio',
        editar: false,
        exact: true,
        component: Vestigio,
      },
      {
        path: '/casos/caso/vestigio/editar/:idVestigio/:idCaso',
        editar: true,
        secao: 'Vestígios',
        titulo: 'Editar vestígio',
        exact: true,
        component: FormEditarVestigio,
      },
      {
        path: '/casos/caso/cadaver/detalhar/:id',
        secao: 'Detalhes do cadáver',
        titulo: 'Detalhes do cadáver',
        editar: false,
        exact: true,
        component: Cadaver,
      },
      {
        path: '/casos/caso/solicitacao',
        secao: 'Detalhes da solicitação de exames',
        titulo: 'Detalhes da solicitação de exames',
        exact: true,
        component: SolicitacaoExames,
      },
      {
        path: '/solicitacoes/solicitadas',
        secao: 'Solicitações de Exame',
        titulo: 'Solicitações de Exame',
        exact: true,
        component: ListaSolicitacoes,
      },
      {
        path: '/solicitacoes/despachos',
        secao: 'Despachos de Solicitações',
        titulo: 'Despachos de Solicitações',
        exact: true,
        component: Despachos,
      },
      {
        path: '/casos/caso/solicitacao/editar/:id',
        editar: true,
        secao: 'Solicitação de exame',
        titulo: 'Formulário de solicitação de exame',
        exact: true,
        component: EditarSolicitacao,
      },
      {
        path: '/casos/caso/solicitacao/adicionarexame/:idSolicitacao',
        editar: false,
        secao: 'Adicionar exame solicitado',
        titulo: 'Formulário para adicionar novo exame à solicitação',
        exact: true,
        origem: 'ADICAO',
        component: EditarExameSolicitado,
      },
      {
        path: '/casos/caso/solicitacao/editarexame/:id',
        editar: true,
        secao: 'Editar exame solicitado',
        titulo: 'Formulário para editar o exame',
        exact: true,
        origem: 'EDICAO',
        component: EditarExameSolicitado,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/detalhar/:id',
        secao: 'Exame Solicitado',
        titulo: 'Detalhes do exame solicitado',
        exact: true,
        component: ExameSolicitado,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/exameLocal/:id',
        secao: 'Exame de Local',
        titulo: 'Detalhes do exame de local',
        exact: true,
        component: ExameLocal,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/alterarStatus/:id',
        secao: 'Alteração de status do exame solicitado',
        titulo: 'Alteração de status do exame solicitado',
        exact: true,
        component: AlterarStatusExame,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/vestigio',
        secao: 'Detalhes do vestígio',
        titulo: 'Detalhes do vestígio',
        editar: false,
        exact: true,
        component: Vestigio,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameEficienciaBalistica/:idExameSolicitado/:idExameRealizado',
        secao: 'Edição do Exame de Eficiência Balística',
        titulo: 'Edição do Exame',
        exact: true,
        component: ExameEficienciaBalistica,
        tipoExame: 'EFICIENCIA_BALISTICA',
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameCoincidenciaPerfis/:idExameSolicitado/:idExameRealizado',
        secao: 'Edição do Exame de Coincidência de Perfis Balísticos',
        titulo: 'Edição do Exame',
        exact: true,
        component: ExameCoincidenciaPerfis,
        tipoExame: 'COINCIDENCIA_PERFIS_BALISTICO',
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoInfoSINAB/:idExameSolicitado/:idExameRealizado',
        secao: 'Edição da Informação Técnica SINAB',
        titulo: 'Edição da Informação',
        exact: true,
        component: InformacaoSINAB,
        tipoExame: 'INFO_TECNICA_SINAB',
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameConfrontoBalistico/:idExameSolicitado/:idExameRealizado',
        secao: 'Edição do Exame de Confronto Balístico',
        titulo: 'Edição do Exame',
        exact: true,
        component: ExameEficienciaBalistica,
        tipoExame: 'CONFRONTO_BALISTICO',
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameIdentificacaoBalistica/:idExameSolicitado/:idExameRealizado',
        secao: 'Edição do Exame de Identificação Balística',
        titulo: 'Edição do Exame',
        exact: true,
        component: ExameIdentificacaoBalistica,
        tipoExame: 'IDENTIFICACAO_BALISTICA',
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameMausTratos/:idExameSolicitado/:idExameRealizado',
        secao: 'Edição do Exame de Eficiência Balística',
        titulo: 'Edição do Exame',
        exact: true,
        component: ExameMausTratos,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameQuimico/:idExameSolicitado/:idExameRealizado',
        secao: 'Edição de Exame Químico',
        titulo: 'Edição de Exame Químico',
        exact: true,
        component: ExameQuimico,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameGenerico',
        secao: 'Edição do Exame',
        titulo: 'Edição do Exame',
        exact: true,
        component: ExameGenerico,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameNecroscopico/:id',
        secao: 'Edição do Exame Necroscópico',
        titulo: 'Edição de Exame',
        exact: true,
        component: ExameNecroscopico,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameNecropapiloscopico/:id',
        secao: 'Edição do Exame Necropapiloscópico',
        titulo: 'Edição de Exame',
        exact: true,
        component: ExameNecropapiloscopico,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameIdentificacaoCadaverica/:id',
        secao: 'Edição do Exame de Identificacao Cadavérica',
        titulo: 'Edição de Exame',
        exact: true,
        component: ExameIdentificacaoCadaverica,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameAchadoCadaver/:id',
        secao: 'Edição do Exame de Achado de Cadáver',
        titulo: 'Edição de Exame',
        exact: true,
        component: ExameLocalAchadoCadaver,
        tipoExame: 'ACHADO_CADAVER',
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameImovel/:id',
        secao: 'Edição do Exame Pericial em Imóvel',
        titulo: 'Edição de Exame',
        exact: true,
        component: ExameImovel,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameAmbiental/:id',
        secao: 'Edição do Exame Pericial Ambiental',
        titulo: 'Edição de Exame',
        exact: true,
        component: ExameAmbiental,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameTentativaHomicidio/:id',
        secao: 'Edição do Exame em Local de Tentativa de Homicídio',
        titulo: 'Edição de Exame',
        exact: true,
        component: ExameTentativaHomicidio,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameConstatacao/:idExameSolicitado/:idExameRealizado',
        secao: 'Edição do Exame de Constatação',
        titulo: 'Edição de Exame',
        exact: true,
        component: ExameConstatacao,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameComparacao/:id',
        secao: 'Edição do Exame de Comparação',
        titulo: 'Edição de Exame',
        exact: true,
        component: ExameComparacao,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameIdentificacaoCriminal/:id',
        secao: 'Edição do Exame de Identificação Criminal',
        titulo: 'Edição de Exame',
        exact: true,
        component: ExameIdentificacaoCriminal,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/edicaoExameNecrodontoscopico/:id',
        secao: 'Edição do Exame Necrodontoscópico',
        titulo: 'Edição de Exame Necrodontoscópico',
        origem: 'NECRODONTOSCOPICO',
        exact: true,
        component: ExameNecrodontoscopico,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/editorExameRealizado/:id',
        secao: 'Editor de Exame',
        titulo: 'Editor de Exame',
        exact: true,
        component: EditorDocumento,
      },
      {
        path: '/casos/caso/solicitacao/exameSolicitado/editorErrata/:id',
        secao: 'Editor de Errata',
        titulo: 'Editor de Errata',
        exact: true,
        errata: true,
        component: EditorDocumento,
      },
      {
        path: '/casos/caso/editorExameRealizado',
        secao: 'Editor de Exame',
        titulo: 'Editor de Exame',
        exact: true,
        component: EditorDocumento,
      },
      {
        path: '/cadaver/editorExameRealizado',
        secao: 'Editor de Exame',
        titulo: 'Editor de Exame',
        exact: true,
        component: EditorDocumento,
      },
      {
        path: '/vestigio/editorExameRealizado',
        secao: 'Editor de Exame',
        titulo: 'Editor de Exame',
        exact: true,
        component: EditorDocumento,
      },
      {
        path: '/casos/caso/cadaver/reconhecimento/:id',
        secao: 'Reconhecimento de Cadáver',
        titulo: 'Reconhecimento de Cadáver',
        exact: true,
        component: ReconhecimentoCadaver,
      },
      {
        path: '/casos/caso/cadaver/entrega/:id',
        secao: 'Entrega de cadáver',
        titulo: 'Entrega de cadáver',
        exact: true,
        component: EntregaCadaver,
      },
      {
        path: '/meuscasos',
        secao: 'Meus casos',
        titulo: 'Meus casos',
        exact: true,
        component: MeusCasos,
      },
      {
        path: '/meuscasos/cadastrar',
        secao: 'Cadastrar caso',
        editar: false,
        titulo: 'Cadastrar caso',
        exact: true,
        component: EditarCaso,
      },
      {
        path: '/casosdosetor',
        secao: 'Casos do Setor',
        titulo: 'Casos do Setor',
        exact: true,
        component: CasosDoSetor,
      },
      {
        path: '/exames',
        secao: 'Exames',
        titulo: 'Exames',
        exact: true,
        component: Exames,
      },
      {
        path: '/vestigios',
        secao: 'Banco de Vestígios',
        titulo: 'Banco de Vestígios',
        exact: true,
        component: ListaVestigios,
      },
      {
        path: '/vestigios/cadastrar',
        editar: false,
        avulso: true,
        secao: 'Vestígios',
        titulo: 'Cadastrar vestígio',
        exact: true,
        component: FormEditarVestigio,
      },
      {
        path: '/vestigios/vestigio',
        secao: 'Detalhes do vestígio',
        titulo: 'Detalhes do vestígio',
        editar: false,
        exact: true,
        component: Vestigio,
      },
      {
        path: '/vestigios/meusvestigios',
        secao: 'Meus vestígios',
        titulo: 'Meus Vestígios',
        editar: false,
        exact: true,
        component: MeusVestigios,
      },
      {
        path: '/vestigios/vestigiosdosetor',
        secao: 'Vestígios do setor',
        titulo: 'Vestígios do setor',
        editar: false,
        exact: true,
        component: VestigiosDoSetor,
      },
      {
        path: '/bancodeexames',
        secao: 'Banco de Exames',
        titulo: 'Banco de Exames',
        editar: false,
        exact: true,
        component: BancoDeExames,
      },
      /**
       * !! Rotulagem antiga
       *   As rotas referentes a /exames correspondem aos tipos de exame
       */
      {
        path: '/exames/cadastrar',
        editar: false,
        secao: 'Tipo de exame',
        titulo: 'Cadastrar exame',
        exact: true,
        component: EditarExame,
      },
      {
        path: '/exames/editar',
        editar: true,
        secao: 'Tipo de exame',
        titulo: 'Editar exame',
        exact: true,
        component: EditarExame,
      },
      {
        path: '/exames/secao/cadastrar',
        editar: false,
        secao: 'Seção do tipo de exame',
        titulo: 'Cadastrar seção do tipo de exame',
        exact: true,
        component: FormularioSecao,
      },
      {
        path: '/exames/secao/editar',
        editar: true,
        secao: 'Seção do tipo de exame',
        titulo: 'Editar seção do tipo de exame',
        exact: true,
        component: FormularioSecao,
      },
      {
        path: '/exames/secoes',
        editar: true,
        secao: 'Seção do tipo de exame',
        titulo: 'Editar seção do tipo de exame',
        exact: true,
        component: ListaSecoes,
      },
      {
        path: '/orgaos',
        secao: 'Orgãos',
        titulo: 'Orgãos',
        exact: true,
        component: Orgaos,
      },
      {
        path: '/orgaos/cadastrar',
        editar: false,
        secao: 'Orgãos',
        titulo: 'Cadastrar orgão',
        exact: true,
        component: EditarOrgao,
      },
      {
        path: '/orgaos/editar',
        editar: true,
        secao: 'Orgãos',
        titulo: 'Editar orgão',
        exact: true,
        component: EditarOrgao,
      },
      {
        path: '/orgaos/regionais',
        secao: 'Regionais',
        titulo: 'Regionais',
        exact: true,
        component: Regionais,
      },
      {
        path: '/orgaos/regionais/cadastrar',
        editar: false,
        secao: 'Regionais',
        titulo: 'Cadastrar regional',
        exact: true,
        component: EditarRegional,
      },
      {
        path: '/orgaos/regionais/editar',
        editar: true,
        secao: 'Regionais',
        titulo: 'Editar regional',
        exact: true,
        component: EditarRegional,
      },
      {
        path: '/orgaos/regionais/divisoes',
        secao: 'Divisões',
        titulo: 'Divisões',
        exact: true,
        global: true,
        component: Divisoes,
      },
      {
        path: '/orgaos/regionais/natal/divisoes',
        secao: 'Divisões',
        titulo: 'Divisões',
        exact: true,
        idRegional: 90,
        global: false,
        component: Divisoes,
      },
      {
        path: '/orgaos/regionais/mossoro/divisoes',
        secao: 'Divisões',
        titulo: 'Divisões',
        exact: true,
        idRegional: 91,
        global: false,
        component: Divisoes,
      },
      {
        path: '/orgaos/regionais/caico/divisoes',
        secao: 'Divisões',
        titulo: 'Divisões',
        exact: true,
        global: false,
        idRegional: 93,
        component: Divisoes,
      },
      {
        path: '/orgaos/regionais/paudosferros/divisoes',
        secao: 'Divisões',
        titulo: 'Divisões',
        exact: true,
        global: false,
        idRegional: 92,
        component: Divisoes,
      },
      {
        path: '/orgaos/regionais/divisoes/cadastrar',
        editar: false,
        secao: 'Divisões',
        titulo: 'Cadastrar divisão',
        exact: true,
        component: EditarDivisao,
      },
      {
        path: '/orgaos/regionais/divisoes/editar',
        editar: true,
        secao: 'Divisões',
        titulo: 'Editar divisão',
        exact: true,
        component: EditarDivisao,
      },
      {
        path: '/orgaos/regionais/divisoes/setores',
        secao: 'Setores',
        titulo: 'Setores',
        exact: true,
        component: Setores,
      },
      {
        path: '/orgaos/regionais/divisoes/setores/cadastrar',
        editar: false,
        secao: 'Setores',
        titulo: 'Cadastrar setor',
        exact: true,
        component: EditarSetor,
      },
      {
        path: '/orgaos/regionais/divisoes/setores/editar',
        editar: true,
        secao: 'Setores',
        titulo: 'Editar setor',
        exact: true,
        component: EditarSetor,
      },
      {
        path: '/presentation',
        exact: true,
        component: Presentation,
      },
      {
        path: '/logsservidor',
        editar: true,
        secao: 'Logs',
        titulo: 'Logs do Servidor',
        exact: true,
        component: LogsServidor,
      },
      {
        path: '/meusexames',
        secao: 'Meus Exames',
        titulo: 'Meus Exames',
        exact: true,
        component: MeusExamesSolicitados,
      },
      {
        path: '/examessolicitados/setor',
        secao: 'Exames Solicitados do Setor',
        titulo: 'Exames Solicitados do Setor',
        exact: true,
        component: ExamesSolicitadosDoSetor,
      },
      {
        path: '/gerenciamentoBalistica',
        secao: 'Gerenciamento dos Dados da Balística',
        titulo: 'Dados Balísticos Gerenciáveis',
        exact: true,
        component: DadosGerenciaveis,
      },
      {
        path: '/gerenciamentoBalistica/dadoGerenciavel',
        secao: 'Gerenciamento de Dado Balístico',
        titulo: 'Dado Gerenciável',
        exact: true,
        component: DadoGerenciavel,
      },
      {
        path: '/dashboards/default',
        exact: true,
        component: DashboardDefault,
      },
      {
        path: '/vestigios/vestigio/extrair/:id',
        exact: true,
        titulo: 'Extrair vestígio',
        secao: 'Extrair vestígio',
        origem: 'VESTIGIO',
        component: ExtracaoVestigio,
      },
      {
        path: '/casos/caso/cadaver/extrair/:id',
        exact: true,
        titulo: 'Extrair vestígio',
        secao: 'Extrair vestígio',
        origem: 'CADAVER',
        component: ExtracaoVestigio,
      },
      {
        path: '/vestigios/vestigio/consumirvestigio/:id',
        exact: true,
        titulo: 'Consumir vestigio',
        secao: 'Consumir vestigio',
        origem: 'VESTIGIO',
        component: ConsumirVestigio,
      },
      // RF 06 - rota para a extração do vestígio do veículo.
      {
        path: '/casos/caso/veiculo/extrair/:id',
        exact: true,
        titulo: 'Extrair vestígio',
        secao: 'Extrair vestígio',
        origem: 'VEICULO',
        component: ExtracaoVestigio,
      },
      {
        path: '/orgaos/regionais/divisoes/setores/cadastrar',
        editar: false,
        secao: 'Setores',
        titulo: 'Cadastrar setor',
        exact: true,
        component: EditarSetor,
      },
      {
        path: '/casos/caso/cadastrarveiculo/:idCaso',
        editar: false,
        secao: 'Veículo',
        titulo: 'Cadastrar veículo',
        exact: true,
        component: EditarVeiculo,
      },
      {
        path: '/casos/caso/editarveiculo/:id',
        editar: true,
        secao: 'Veículo',
        titulo: 'Editar veículo',
        exact: true,
        component: EditarVeiculo,
      },
      {
        path: '/casos/caso/veiculo/detalhar/:id',
        editar: false,
        secao: 'Detalhes do veículo',
        titulo: 'Detalhes do veículo',
        exact: true,
        component: Veiculo,
      },
      {
        path: '/bancodecadaveres',
        secao: 'Banco de Cadáveres',
        titulo: 'Banco de Cadáveres',
        editar: false,
        exact: true,
        component: BancoDeCadaveres,
      },
      {
        path: '/gerenciamentodevagas',
        secao: 'Gerenciamento de Vagas',
        titulo: 'Gerenciamento de Vagas',
        editar: false,
        exact: true,
        component: GerenciamentoDeVagas,
      },
      {
        path: '/gerenciamentodevagas/cadastrodevagas',
        secao: 'Cadastro de Vagas',
        titulo: 'Cadastro de Vagas',
        editar: false,
        exact: true,
        component: CadastroDeVagas,
      },
      {
        path: '/solicitacaoexame/fichasolicitacaoexame/detalhar/:id',
        secao: 'Detalhes da Solicitação de Exames',
        titulo: 'Detalhes da Solicitação de Exames',
        editar: true,
        exact: true,
        component: FichaSolicitacaoExame,
      },
      {
        path: '/reportpage',
        secao: 'Página de Feedback',
        titulo: 'Pagina de Feedback',
        editar: true,
        exact: true,
        component: ReportPage,
      },
      {
        path: '/reportpage/cadastroreport',
        secao: 'Cadastro de Feedback',
        titulo: 'Cadatrar Feedback',
        editar: true,
        exact: true,
        component: CadastroReport,
      },
      {
        path: '/reportpage/gerenciareport',
        secao: 'Gerenciar Feedback',
        titulo: 'Gerenciar Feedback',
        editar: true,
        exact: true,
        component: GerenciarReport,
      },
      {
        path: '/casos/caso/exameSolicitado/cancelarExame/:idExameSolicitado/:idExameRealizado',
        secao: 'Exame Solicitado',
        titulo: 'Cancelar Exame',
        editar: true,
        exact: true,
        component: CancelarExame,
      },
      {
        path: '/bancodepericiando',
        secao: 'Banco de Periciandos',
        titulo: 'Banco de Periciandos',
        editar: false,
        exact: true,
        component: BancoDePericiando,
      },
      {
        path: '/exameSolicitado/adicionarInformacao/:idObjeto',
        secao: 'Adicionar Informação',
        titulo: 'Adicionar Informação',
        origem: 'EXAME_SOLICITADO',
        editar: false,
        exact: true,
        component: FormularioInformacao,
      },
      {
        path: '/caso/adicionarInformacao/:idObjeto',
        secao: 'Adicionar Informação',
        titulo: 'Adicionar Informação',
        origem: 'CASO',
        editar: false,
        exact: true,
        component: FormularioInformacao,
      },
      {
        path: '/periciando/adicionarInformacao/:idObjeto',
        secao: 'Adicionar Informação',
        titulo: 'Adicionar Informação',
        origem: 'PERICIANDO',
        editar: false,
        exact: true,
        component: FormularioInformacao,
      },
      {
        path: '/cadaver/adicionarInformacao/:idObjeto',
        secao: 'Adicionar Informação',
        titulo: 'Adicionar Informação',
        origem: 'CADAVER',
        editar: false,
        exact: true,
        component: FormularioInformacao,
      },
      {
        path: '/veiculo/adicionarInformacao/:idObjeto',
        secao: 'Adicionar Informação',
        titulo: 'Adicionar Informação',
        origem: 'VEICULO',
        editar: false,
        exact: true,
        component: FormularioInformacao,
      },
      {
        path: '/local/adicionarInformacao/:idObjeto',
        secao: 'Adicionar Informação',
        titulo: 'Adicionar Informação',
        origem: 'LOCAL',
        editar: false,
        exact: true,
        component: FormularioInformacao,
      },
      {
        path: '/solicitacaoExame/adicionarInformacao/:idObjeto',
        secao: 'Adicionar Informação',
        titulo: 'Adicionar Informação',
        origem: 'SOLICITACAO_EXAME',
        editar: false,
        exact: true,
        component: FormularioInformacao,
      },
      {
        path: '/vestigio/adicionarInformacao/:idObjeto',
        secao: 'Adicionar Informação',
        titulo: 'Adicionar Informação',
        origem: 'VESTIGIO',
        editar: false,
        exact: true,
        component: FormularioInformacao,
      },
      {
        path: '/anuncio/cadastraranuncio',
        secao: 'Cadastrar Anúncio',
        titulo: 'Cadastrar Anúncio',
        editar: false,
        exact: true,
        component: CadastrarAnuncio,
      },
      {
        path: '/anuncio/anuncios',
        secao: 'Anúncio',
        titulo: 'Anúncio',
        editar: false,
        exact: true,
        component: Anuncios,
      },
      {
        path: '/anuncio/detalhes/:id',
        secao: 'Detalhes do anúncio',
        titulo: 'Detalhes do anúncio',
        exact: true,
        component: Anuncio,
      },
      {
        path: '/cadaver/inumar/:id',
        secao: 'Inumar Cadáver',
        titulo: 'Inumar Cadáver',
        origem: 'CADAVER',
        editar: false,
        exact: true,
        component: InumarCadaver,
      },
      {
        path: '/cadaver/exumar/:id',
        secao: 'Exumar Cadáver',
        titulo: 'Exumar Cadáver',
        origem: 'CADAVER',
        editar: false,
        exact: true,
        component: ExumarCadaver,
      },
      {
        path: '/requisicoes',
        secao: 'Requisições',
        titulo: 'Requisições',
        editar: false,
        exact: true,
        component: Requisicoes,
      },
      {
        path: '/requisicoes/requisicao/detalhar/:id',
        editar: true,
        secao: 'Requisições',
        titulo: 'Detalhes da Requisição',
        exact: true,
        component: Requisicao,
      },
      {
        path: '/vestigios/lote/:idLote',
        exact: true,
        origem: 'BancoDeVestigios',
        titulo: 'Lote de vestígios',
        secao: 'Lote de vesígios',
        component: Lote,
      },
      {
        path: '/vestigios/meusvestigios/lote/:idLote',
        exact: true,
        origem: 'MeusVestigios',
        titulo: 'Lote de vestígios',
        secao: 'Lote de vesígios',
        component: Lote,
      },
      {
        path: '/vestigios/vestigiossetor/lote/:idLote',
        exact: true,
        origem: 'VestigiosSetor',
        titulo: 'Lote de vestígios',
        secao: 'Lote de vesígios',
        component: Lote,
      },
      {
        path: '/solicitacoesexames',
        exact: true,
        titulo: 'Solicitações',
        secao: 'Solicitações',
        component: Despachos,
      },
      {
        path: '/galeria/:tipo/:id',
        exact: true,
        titulo: 'Galeria de fotos',
        secao: 'Galeria de fotos',
        component: Galeria,
      },
      {
        path: '/centraldecustodia',
        exact: true,
        titulo: 'Central de Custódia',
        secao: 'Central de Custódia',
        component: CentralDeCustodia,
      },
      {
        path: '/centraldecustodia/vestigio',
        secao: 'Detalhes do vestígio',
        titulo: 'Detalhes do vestígio',
        editar: false,
        centralCustodia: true,
        exact: true,
        component: Vestigio,
      },
      {
        path: '/centraldecustodia/vestigio/cancelarencaminhamento/:id',
        editar: false,
        secao: 'Vestígios',
        titulo: 'Cancelar encaminhamento de vestígio',
        exact: true,
        component: CancelarEncaminharVestigio,
      },
      {
        path: '/centraldecustodia/vestigio/descartar/:id',
        secao: 'Vestígios',
        titulo: 'Descartar vestígio',
        exact: true,
        component: DescartarVestigio,
      },
      {
        path: '/gerenciarusuarios',
        secao: 'Usuários',
        titulo: 'Usuários',
        exact: true,
        component: Usuarios,
      },
      {
        path: '/gerenciarusuarios/cadastrar',
        editar: false,
        secao: 'Usuários',
        titulo: 'Cadastrar usuário',
        exact: true,
        component: EditarUsuario,
      },
      {
        path: '/gerenciarusuarios/editar/:idUsuario',
        editar: true,
        secao: 'Usuários',
        titulo: 'Editar usuário',
        exact: true,
        component: EditarUsuario,
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
]

export default routes
